import axios from 'axios'

// const BASE_URL = 'http://localhost/api/'
 const BASE_URL = 'https://desk.bankpdf.ru/api/'

const instance = axios.create({
  baseURL: BASE_URL,
  timeout: false,
  params: {} // do not remove this, its added to add params later in the config
})

// Add a request interceptor
instance.interceptors.request.use(function (config) {
  /* global window Store */
//  const {token} = Store.state.user
  const cookiestring = RegExp("token=[^;]+").exec(document.cookie);
  const token = decodeURIComponent(cookiestring ? cookiestring.toString().replace(/^[^=]+./, "") : "");

  console.log("token", token)
  if (token) {
    config.headers.common['Authorization'] = 'Bearer ' + token
    config.headers.common['Content-Type'] = 'application/x-www-form-urlencoded'
  } else {
    // Use application/x-www-form-urlencoded for login
    config.headers.common['Content-Type'] = 'application/x-www-form-urlencoded'
  }
  return config
}, function (error) {
  // Do something with request error
  return Promise.reject(error)
})

instance.interceptors.response.use((response) => response, (error) => {
  console.log(error.response.data.result)
  if (error.response.data.result === 'unauth'){
    const cookiestring = RegExp("token=[^;]+").exec(document.cookie);
    const token = decodeURIComponent(cookiestring ? cookiestring.toString().replace(/^[^=]+./, "") : "");
    if (token) {
        window.location.href = '/logout';
    }
  }
  if (error.response.data.result === 'unpaid' && !window.location.href.match(/unpaid/)){
      window.location.href = '/unpaid';
  }
  return Promise.reject(error)
})

export default {
  getData (action) {
    let url = `${BASE_URL}`
    url += action
    return instance.get(url)
  },
  postData (action, data) {
    let url = `${BASE_URL}`
    url += action
    return instance.post(url, data)
  },
  putData (action, data) {
    let url = `${BASE_URL}`
    url += action
    return instance.put(url, data)
  },
  deleteData (action) {
    let url = `${BASE_URL}`
    url += action
    return instance.delete(url)
  },
  login (action, data) {
    let url = `${BASE_URL}`
    url += action
    return instance.post(url, data)
  }
}



// WEBPACK FOOTER //
// ./src/utils/backend-api.js